import { Button, Grid } from '@mui/material';
import { Fragment, useState } from 'react';
import { z } from 'zod';

import { FormMap } from '@/components/management/FormMap';
import { withFieldGroup } from '@/hooks/useAppForm';

export const CoordinatesFieldGroup = withFieldGroup({
  defaultValues: {
    longitude: null as unknown as number,
    latitude: null as unknown as number,
  },
  props: {
    disabled: false,
  },
  render: function Render({ group, disabled }) {
    const [isMapOpen, setIsMapOpen] = useState(false);

    const handleMapOpen = () => {
      setIsMapOpen(true);
    };

    const handleLocationSelect = (lng: number, lat: number) => {
      group.setFieldValue('longitude', lng);
      group.setFieldValue('latitude', lat);
      setIsMapOpen(false);
    };

    return (
      <Fragment>
        <Grid container spacing={2}>
          <Grid size="grow">
            <group.AppField
              name="longitude"
              validators={{
                onChange: z.number().min(-180, 'Ungültiger Wert').max(180, 'Ungültiger Wert'),
              }}
            >
              {(field) => <field.NumberField label="Längengrad" />}
            </group.AppField>
          </Grid>

          <Grid size="grow">
            <group.AppField
              name="latitude"
              validators={{
                onChange: z.number().min(-90, 'Ungültiger Wert').max(90, 'Ungültiger Wert'),
              }}
            >
              {(field) => <field.NumberField label="Breitengrad" />}
            </group.AppField>
          </Grid>

          <Grid size="auto">
            <Button disabled={disabled} onClick={handleMapOpen} sx={{ height: 56 }} variant="outlined">
              Karteneingabe
            </Button>
          </Grid>
        </Grid>

        {isMapOpen ? (
          <FormMap
            initialLatitude={group.getFieldValue('latitude') ?? undefined}
            initialLongitude={group.getFieldValue('longitude') ?? undefined}
            onClose={() => setIsMapOpen(false)}
            onLocationSelect={handleLocationSelect}
          />
        ) : null}
      </Fragment>
    );
  },
});
